import request from "@/utils/request";

export default function removeResource(id) {
    return request({
        url: `/storeProductResource/agency/remove/`+id,
        method: 'get',
    })
}
